<template>
  <div class="Inside_line_detail" :style="screenHeight">
    <div class="fixed_search" style="height:100px;">
      <div class="fixed_search_input">
        <Input v-model="callerNum" placeholder="请输入主叫号码" title="主叫号码" clearable/>
      </div>
      <div class="fixed_search_input">
        <Input v-model="calleeNum" placeholder="请输入被叫号码" title="被叫号码" clearable/>
      </div>
      <div class="fixed_search_input">
        <Select v-model="callType" placeholder="请选择呼叫类型" clearable title="呼叫类型">
          <Option v-for="(option, index) in callTypeList" :value="option.id" :key="index">{{ option.name }}</Option>
        </Select>
      </div>
      <div class="fixed_search_input compare_select">
        <Select v-model="compareSendCount"  clearable title="选择">
          <Option v-for="(option, index) in compareList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
        <Input v-model="sendCount" placeholder="请输入失败次数" title="失败次数" clearable/>
      </div>
      <!-- <div class="fixed_search_input">
        <Input v-model="sendCount" placeholder="请输入失败次数" title="失败次数" clearable/>
      </div> -->
      <div class="date_input fixed_search_input">
        <el-date-picker v-model="starEndTime" :clearable="false" unlink-panels type="datetimerange" title="通话时间" start-placeholder="开始通话时间" end-placeholder="结束通话时间"
          align="left" :default-time="['00:00:00', '23:59:59']" :editable="editable" :picker-options="pickerOptions" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </div>
      
      <div class="date_input fixed_search_input">
        <el-date-picker v-model="sendTime" :clearable="false" unlink-panels type="datetimerange" title="上次推送时间" start-placeholder="上次开始推送时间" end-placeholder="上次结束通话时间"
          align="left" :default-time="['00:00:00', '23:59:59']" :editable="editable" :picker-options="pickerOptions" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </div>
      <div class="fixed_operation_btn">
        <Button type="primary" @click="initSearch">查询</Button>
        <Button type="primary" class="operation_btn reset_btn" @click="reset">重置</Button>
        <Button type="info" class="operation_btn" style="margin-left: 10px" v-if="roleList['8_2-8-1']" @click="batchpush">批量推送</Button>
      </div>
    </div>
    <div class="fixed_table">
      <el-table :data="contentList" style="width: 100%" :height="tableHeight" class="element_table" :class="{'tableClass':tableClass}" stripe ref="selection"  @cell-click="reportCallScreen" :cell-class-name="showColor"  @selection-change="getSelectedCdrId" >
        <el-table-column v-for="(item, index) in fieldList" align="center" :show-overflow-tooltip="true" :type="item.type" :key="index" :fixed="item.fixed" :prop="item.key" :label="item.title" :width="item.width">

        </el-table-column>
        <el-table-column fixed="right" label="操作" width="150" align="center" v-if="roleList['8_2-8-2'] || roleList['8_2-8-3']">
          <template slot-scope="scope">
            <el-button  @click="pushRecord(scope.row.id)" type="text" size="small"  v-show="roleList['8_2-8-2']">推送</el-button>
            <el-button  @click="checkRecord(scope.row.id)" type="text" size="small"  v-show="roleList['8_2-8-3']">查看日志</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Spin size="large" fix v-if="spinShow">
        <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
        <div>正在加载中...</div>
      </Spin>
    </div>
    <div class="page_style">
      <Page :total="total" size="small" :page-size="pageSize" :current="currentPage" :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
      <div style="padding-top: 2px">跳至</div>
      <Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/>
      <div style="padding-top: 2px">页</div>
    </div>
    <BatchpushPop  @closebatchpushPop="closebatchpushPop"  :showbatchpushPop="showbatchpushPop"></BatchpushPop>
     <publicDialerPage @closePublicDialerPage="closePublicDialerPage" :showPublicDialer="showPublicDialer" :callUpPhone="callUpPhone"></publicDialerPage>
    <PublicSendMessage @closeSendMessage="closeSendMessage" :showSendMessage="showSendMessage" :callUpPhone="callUpPhone"></PublicSendMessage>
    <RecodePop @closeRecode="closeRecode" :showRecode="showRecode" :tipserror="tipserror"></RecodePop>
  </div>
</template>

<script>
import {publicFunClass} from "@/components/js/PublicFunClass.js";
import {customerPublicBtn} from '@/components/js/CustomerPublicBtn.js'
import BatchpushPop from '@/components/statisticsReportForm/detailedReportForm/BatchpushPop.vue'
 import publicDialerPage from '@/components/login/PublicDialerPage.vue'
  import PublicSendMessage from '@/components/login/PublicSendMessage.vue'
import RecodePop from '@/components/statisticsReportForm/detailedReportForm/RecodePop.vue'
  
export default {
  name: "NotpushedBill",
  mixins:[publicFunClass,customerPublicBtn],
  components: {
    BatchpushPop,
     publicDialerPage,
      PublicSendMessage,
      RecodePop
  },
  props: {
    pageCode: String,
  },
  data() {
    return {
      showPageCount: 0,
      roleList: JSON.parse(localStorage.getItem("roleList")),
      screenHeight: { height: "" },
      tableHeight: 600,
      total: 0,
      pageSizeList: [10, 20, 30, 40, 50, 100, 200],
      currentPage: 1,
      pageSize: 20,
      speedChangePage: 1,
      spinShow: false,
      editable:false,
      checkedAll: false,

      callerNum: "",
      calleeNum: "",
      sendCount:"",
      callType: "",
      callTypeList: [
        { id: "1", name: "呼入" },
        { id: "2", name: "手动呼出" },
        { id: "3", name: "自动呼出" },
        { id: "4", name: "内线" }
      ],
      fieldList: [
        { type: "selection", width: 50 },
        { width: 200, key: "callerNum", title: "主叫号码" },
        { width: 200, key: "calleeNum", title: "被叫号码" },
        { key: "callType", title: "呼叫类型" },
        { key: "startTime", title: "通话时间" },
        { key: "sendtime", title: "上次推送时间" },
        { key: "sendCount", title: "失败次数" },
      ],
      contentList: [],
      checkIds: [],
      starEndTime: [
        this.getDate(new Date(), "00:00:00"),
        this.getDate(new Date(), "23:59:59"),
      ],
      sendTime: [
        this.getDate(new Date(), "00:00:00"),
        this.getDate(new Date(), "23:59:59"),
      ],
      journalType: "null",
      menuId: "null",
      showbatchpushPop: false,
      compareSendCount:"",
      compareList:[{'id':'>','name':'大于'},{'id':'<','name':'小于'},{'id':'>=','name':'大于等于'},{'id':'=','name':'等于'},{'id':'<=','name':'小于等于'}],
      tableClass: true,
      configInfo: JSON.parse(localStorage.getItem("configInfo")),
      showRecode:false,
      tipserror:'',
      queryParam: null,
   };
  },
  methods: {
    initSearch: function () {
        let that=this;
        let param={
          callerNum:this.callerNum,
          calleeNum:this.calleeNum,
          callType:this.callType,
          compareSendCount:this.compareSendCount,
          sendCount:this.sendCount,
          starEndTime:this.starEndTime.length==0?"":this.starEndTime.toString(),
          sendTime:this.sendTime.length==0?"":this.sendTime.toString(),
          pageNum:this.currentPage,
          pageSize:this.pageSize,
          journalType:"null",
          menuId:"null",
        };
        this.spinShow=true;
        this.$emit("closeVn",true);
        this.queryParam = param;
        this.$http.post("missPushCall/toIndex.json",param) .then(function (res) {
          let result=res.data;
          that.spinShow=false;
          if(result.flag!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          that.checkIds=[];
          that.contentList=res.data.obj.list.content;
          that.total=res.data.obj.list.totalSize;
          for(let i=0;i< that.contentList.length;i++){
            let tablecalltype=that.contentList[i].callType;
            if(tablecalltype=='1'){
              that.contentList[i].callType="呼入";
            }else if(tablecalltype=='2'){
              that.contentList[i].callType="手动呼出";
            }else if(tablecalltype=='3'){
              that.contentList[i].callType="自动呼出";
            }else if(tablecalltype=='4'){
              that.contentList[i].callType="内线";
            }else if(tablecalltype=='5'){
              that.contentList[i].callType="环回测试";
            }
          }

        })
    },
    reset: function () {
        this.callerNum="";
        this.calleeNum="";
        this.callType="";
        this.sendCount="";
        this.compareSendCount="";
        this.starEndTime=[this.getDate(new Date(),'00:00:00'),this.getDate(new Date(),'23:59:59')];
        this.sendTime=[this.getDate(new Date(),'00:00:00'),this.getDate(new Date(),'23:59:59')];
    },
 
    //推送
    pushRecord:function (id) {
            let that=this;
            let param={
                journalType:"统计报表=>未推送话单=>批量推送",
                menuId:"8_2-8-1",
                type:"0",
                ids:id,
              };
            this.$Modal.confirm({
              title: '提示',
              content: "是否确定推送",
              onOk: () => {
                that.$http.post("missPushCall/doSends.json",param) .then(function (res) {
                  let result=res.data.flag;
                  if(result!="666"){
                    that.$alert(res.data.msg, '提示', {
                      confirmButtonText: '确定'
                    });
                    return false;
                  }
                  that.$Message.info("操作成功:"+res.data.msg);
                  that.initSearch();
                });
              }
            });
    },
    getSelectedCdrId:function(selection){
        this.checkIds=[];
        for (let i=0;i<selection.length;i++){
          this.checkIds.push(selection[i].cdrId)
        }
    },
    
    //批量推送
    batchpush:function () {
      this.showbatchpushPop=true;
    },
    //关闭批量推送
    closebatchpushPop:function(flag,pushStyle){
      this.showbatchpushPop=false;
      if (flag) {
              let param=[];
              if (pushStyle=='0'){//选中结果推送
                if (this.checkIds.length==0){
                  this.$Modal.info({
                    title:'提示',
                    content:"请选择要推送的数据"
                  });
                  return false;
                }
                 param={
                  type:pushStyle,//1搜索 0选中
                  ids:this.checkIds.toString(),
                  journalType:"统计报表=>未推送话单=>批量推送",
                  menuId:"8_2-8-1",

                };
              }else if (pushStyle=='1'){//搜索结果删除
                if(this.contentList.length==0){
                  this.$Modal.info({
                    title:'提示',
                    content:"当前没有可推送的数据"
                  });
                  return false;
                }
                if(!this.queryParam){
                  this.$Modal.info({
                    title:'提示',
                    content:"请点击查询后再推送"
                  });
                  return false;
                }

                delete this.queryParam["pageNum"];
                delete this.queryParam["pageSize"];

                this.$set(this.queryParam, 'journalType', '统计报表=>未推送话单=>批量推送');
                this.$set(this.queryParam, 'menuId', '8_2-8-1');
                this.$set(this.queryParam, 'type', pushStyle);

                param = this.queryParam;
              }
              let that=this;
              that.$Modal.confirm({
                    title: '提示',
                    content: "是否确定推送",
                    onOk: () => {
                      that.$http.post("missPushCall/doSends.json",param) .then(function (res) {
                        let result = res.data.flag;
                        if(result!="666"){
                          that.$alert(res.data.msg, '提示', {
                            confirmButtonText: '确定'
                          });
                          return false;
                        }
                        that.$Message.info("操作成功:"+res.data.msg);
                        that.initSearch();
                      });
                    }
              });
            }




    },
    //查看日志
    checkRecord:function (id) {
        let that=this;
        let param={
           id:id,
        };
        this.$http.post("missPushCall/doSelectOne.json",param) .then(function (res) {
          let result=res.data;
          if(result.flag!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          that.tipserror=res.data.obj.errorReason;
          if(that.tipserror==""){
              that.tipserror="暂无日志";
          }
          console.log(that.tipserror);
          that.showRecode=true;


        })

    },
    closeRecode:function () {
          this.showRecode=false;
    }
  },
  created() {
    this.screenHeight.height = this.mountHeight(91);
    let clientHeight = document.documentElement.clientHeight;
    this.tableHeight = clientHeight - 230;
  },
  destroyed(){
      this.$emit("closeVn",true);
    },
  watch: {
    pageCode: function () {
      if (this.pageCode == "8_2-8" && this.showPageCount == 0) {
        this.$emit("openVn", true);
        this.showPageCount++;
        this.initSearch();
      }
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/statisticsReportForm/detailedReportForm/NotpushedBill.vue